import { AGR_CUL_PLANTINGS_ITEM } from './agr-cul-plantings.js'
import { AGR_CUL_CAMPAIGNS_ITEM } from './agr-cul-campaigns.js'
import { AGR_CUL_SIMULACIONES_ITEM } from './agr-cul-simulaciones.js'
import { AGR_CUL_RIEGO_ITEM } from './agr-cul-riego.js'
import { AGR_CUL_FERTILIZACION_ITEM } from './agr-cul-fertilizacion.js'
import { AGR_CUL_CONFIG_ITEM } from './agr-cul-config.js'
import { AGR_CUL_COSTOS_ITEM } from './agr-cul-costos.js'

/** @type {import('../help-index.js').HelpScreen} */
export const AGR_CUL_HELP = {
  screenId: 'agr-cul',
  label: 'Cultivos',
  navPath: 'Agro → Cultivos',
  keywords: [
    'agro', 'cultivo', 'siembra', 'campaña', 'riego', 'fertilización',
    'simulación', 'kc', 'nutriente', 'extracción', 'costo',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'En Cultivos gestionás campañas, siembras, planes de riego y fertilización, simulaciones y la configuración técnica de cada cultivo. Orden típico: Configuración → Campañas → Cultivos (siembras) → Riego / Fertilización.',
  sidebarItems: [
    AGR_CUL_PLANTINGS_ITEM,
    AGR_CUL_CAMPAIGNS_ITEM,
    AGR_CUL_SIMULACIONES_ITEM,
    AGR_CUL_RIEGO_ITEM,
    AGR_CUL_FERTILIZACION_ITEM,
    AGR_CUL_COSTOS_ITEM,
    AGR_CUL_CONFIG_ITEM,
  ],
}
